import { render, staticRenderFns } from "./Country Guide 2026.vue?vue&type=template&id=29227afb&"
import script from "./Country Guide 2026.vue?vue&type=script&lang=js&"
export * from "./Country Guide 2026.vue?vue&type=script&lang=js&"
import style0 from "./Country Guide 2026.vue?vue&type=style&index=0&id=29227afb&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIProgressBar: require('/opt/build/repo/components/UI/ProgressBar.vue').default,UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,BlocksArticleHero: require('/opt/build/repo/components/Blocks/ArticleHero.vue').default,BlocksArticleStickyNav: require('/opt/build/repo/components/Blocks/ArticleStickyNav.vue').default,BlocksArticleSidebar: require('/opt/build/repo/components/Blocks/ArticleSidebar.vue').default,CardsAutoRecommend: require('/opt/build/repo/components/Cards/AutoRecommend.vue').default,BlocksBannerHeroCards: require('/opt/build/repo/components/Blocks/BannerHeroCards.vue').default,UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
